import React, {useEffect, useState} from 'react';
import {getAgeStats, getConsents, getConsentStats, getCustomer, getGeoStats} from "./api";
import { Row, Col, Card } from "react-bootstrap";
import { IconChevronRight } from "@tabler/icons-react";
import MainLayout from "./components/MainLayout";
import CustomerStats from "./components/charts/CustomerStats";
import AgeChart from "./components/charts/AgeChart";
import ConsentsChart from "./components/charts/ConsentsChart";
import CountriesMapChart from "./components/charts/CountriesMapChart";
import ConsentChildStats from "./components/charts/ConsentChildStats";
import dayjs from 'dayjs';

function Dashboard() {
  const [consentStats, setConsentStats] = useState<any>()
  const [ageStats, setAgeStats] = useState<any>()
  const [geoStats, setGeoStats] = useState<any>()
  const [consents, setConsents] = useState<any>()
  const [customer, setCustomer] = useState<any>()
  useEffect(() => {
    if (!consentStats) {
      getConsentStats().then(r => setConsentStats(r.data))
    }
    if (!ageStats) {
      getAgeStats().then(r => setAgeStats(r.data))
    }
    if (!geoStats) {
      getGeoStats().then(r => setGeoStats(r.data))
    }
    if (!customer) {
      getCustomer().then(r => setCustomer(r.data))
    }
    if (!consents) {
      const currentTime = dayjs();
      getConsents(currentTime.subtract(30, 'minute').toISOString(), currentTime.toISOString()).then(res => setConsents(res.data)).catch(console.error)
    }
  }, [])

  return (
    <MainLayout>
      <Row className="g-4">
        <Col md={6}>
          <Row className="g-4">
            <Col sm={12}>
              <div className="chart-title">
                <h6> Progress Overview</h6>
              </div>
              <Card>
                <Card.Body>
                  <CustomerStats customer={customer} />
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <div className="chart-title">
                <h6>Ages</h6>
                <IconChevronRight color="currentColor" size={22} />
              </div>
              <Card>
                <Card.Body>
                  <AgeChart ageStats={ageStats} />
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <div className="chart-title">
                <h6>Consents last 5 minutes</h6>
                <IconChevronRight color="currentColor" size={22} />
              </div>
              <Card>
                <Card.Body>
                  <ConsentsChart consents={consents} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md={6} className="">
          <div className="chart-title">
            <h6>Countries</h6>
            <IconChevronRight color="currentColor" size={22} />
          </div>
          <Card>
            <Card.Body>
              <CountriesMapChart geoStats={geoStats} />
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <div className="chart-title">
            <h6>Consent</h6>
          </div>
          <div className="donut-chart-outer">
            <ConsentChildStats
              customLegendId="customLegend"
              subtitleId="legendSubtitle"
              consentStats={consentStats}
            />
          </div>  
        </Col>
      </Row>
    </MainLayout>
  );
}

export default Dashboard;
